import { CuttingCustomHole, FastenerBasePointEnum } from '../models/cutting/cutting-custom-hole.model';
import { PlateTypeEnum } from '../models/cutting/cutting-panel-outline.model';
import { Position } from '../models/cutting/cutting-svg.model';

export interface CustomHoleCoordinates {
  x: number;
  y: number;
  z: number;
}

// @dynamic
export class FastenersHelper {
  static recalcFastenersSetHole(
    side: Position,
    direction: FastenerBasePointEnum,
    fastenerSetPlate: PlateTypeEnum
  ): (hole: CuttingCustomHole, basePoint: CustomHoleCoordinates) => CuttingCustomHole {
    return (hole: CuttingCustomHole, basePoint: CustomHoleCoordinates): CuttingCustomHole => {
      const horizontal = side === 'tc' || side === 'bc';

      const xOffset = horizontal ? basePoint.y : basePoint.x;
      const yOffset = horizontal ? basePoint.x : basePoint.y;

      const backPlate = fastenerSetPlate === PlateTypeEnum.Back;

      hole.y += yOffset;
      hole.x += xOffset;
      hole.basePoint = direction;

      if (horizontal) {
        [hole.x, hole.y] = [hole.y, hole.x];
      }

      if (backPlate) {
        switch (hole.type) {
          case PlateTypeEnum.Back:
            hole.type = PlateTypeEnum.Face;
            break;

          case PlateTypeEnum.Face:
            hole.type = PlateTypeEnum.Back;
            break;
        }
      }

      return hole;
    };
  }
}
